import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Tabs } from 'antd';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import Loading from '../../components/base/Loading';
import { Text } from '../../components/base/Text';
import AssistantFlows from './AssistantFlows';
import AssistantLogs from './AssistantLogs';
const { TabPane } = Tabs;
export const AssistantView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const activeTabKey = location.pathname.split('/').pop() || 'flows';
    const handleTabChange = (key) => {
        navigate(`/assistant/${key}`);
    };
    return (React.createElement("div", { style: { padding: '1.5vw', overflowY: 'auto' } },
        React.createElement(Text, { value: 'Assistant', className: "header1" }),
        React.createElement(Tabs, { defaultActiveKey: activeTabKey, activeKey: activeTabKey, onChange: handleTabChange, type: "line", size: "large" },
            React.createElement(TabPane, { tab: "Flows", key: 'flows' },
                React.createElement(AssistantFlows, null),
                ";"),
            React.createElement(TabPane, { tab: "Flow logs", key: 'logs' },
                React.createElement(AssistantLogs, null)))));
};
export const RelyantAssistantView = withAuthenticationRequired(AssistantView, {
    onRedirecting: () => React.createElement(Loading, null),
});
